export default defineNuxtRouteMiddleware(({ path, query, hash }) => {
  const config = useRuntimeConfig();

  if (path !== '/' && path.endsWith('/') && config.public.siteEnvironment !== 'dev') {
    const nextPath = path.replace(/\/+$/, '') || '/';
    return navigateTo({ path: nextPath, query, hash }, { redirectCode: 301 });
  }
});
